const COUNTRIES = ['AUS', 'NZL', 'GBR', 'IRL', 'ZAF', 'FRA', 'HKG', 'SGP']
const USA_CA = ['USA', 'CAN']
const OTHER = ['JPN', 'SWE', 'MEX', 'NOR', 'FIN', 'DEU', 'CHL', 'ARG', 'UAE', 'URY', 'KOR', 'PER', 'MUS', 'BRA', 'ITA', 'DNK', 'IND', 'ESP', 'MYS']
// const CODES = ['THOROUGHBRED', 'HARNESS', 'GREYHOUND']
const CODES = ['THOROUGHBRED', 'HARNESS']

const store = {
  namspaced: true,
  state: {
    raceNavFilters: {
      countries: [...COUNTRIES, 'USA/CAN', 'OTHER'],
      codes: CODES
    }
  },
  mutations: {
    updateCountries (state, value) {
      state.raceNavFilters.countries = value
    },
    updateCodes (state, value) {
      state.raceNavFilters.codes = value
    }
  },
  actions: {},
  getters: {
    getIsCountrySelectedFilter (state) {
      return state.raceNavFilters.countries
    },
    getCountriesFilter (state) {
      let result = [...state.raceNavFilters.countries]
      if (state.raceNavFilters.countries.includes('OTHER')) {
        result = [...result, ...OTHER]
      } if (state.raceNavFilters.countries.includes('USA/CAN')) {
        result = [...result, ...USA_CA]
      }
      return result
    },
    getIsCodesSelectedFilter (state) {
      return state.raceNavFilters.codes
    }
  }
}

export default store

export const defaultCountries = [...COUNTRIES, 'USA/CAN', 'OTHER']
// export const defaultCodes = ['THOROUGHBRED', 'HARNESS', 'GREYHOUND']
export const defaultCodes = ['THOROUGHBRED', 'HARNESS']
